// extracted by mini-css-extract-plugin
export var box = "Benefits-module--box--149bd";
export var box_md = "Benefits-module--box_md--56efa";
export var box_xmd = "Benefits-module--box_xmd--4390d";
export var box_flex = "Benefits-module--box_flex--05560";
export var box_lg = "Benefits-module--box_lg--23cea";
export var box_sm = "Benefits-module--box_sm--1e615";
export var box_outer = "Benefits-module--box_outer--116ee";
export var box_whiteBg = "Benefits-module--box_white-bg--b49cd";
export var box_noMarginBottom = "Benefits-module--box_no-margin-bottom--c9299";
export var box_noPadding = "Benefits-module--box_no-padding--cac77";
export var box_outerGray = "Benefits-module--box_outer-gray--ecf06";
export var box_dark = "Benefits-module--box_dark--0087d";
export var box_zIndex = "Benefits-module--box_z-index--7dd5c";
export var box_zIndex6 = "Benefits-module--box_z-index-6--c4d6e";
export var box_eventsWithLine = "Benefits-module--box_events-with-line--316f5";
export var box_featuresAo = "Benefits-module--box_features-ao--2062c";
export var box_verticalPaddings = "Benefits-module--box_vertical-paddings--2576c";
export var clearP = "Benefits-module--clearP--736a8";
export var clearP_vc = "Benefits-module--clearP_vc--d88f0";
export var container = "Benefits-module--container--127a4";
export var layout = "Benefits-module--layout--0afc7";
export var gridWrapper = "Benefits-module--gridWrapper--034c7";
export var separator = "Benefits-module--separator--c60b0";
export var partners = "Benefits-module--partners--c95f1";
export var partnerTitle = "Benefits-module--partnerTitle--1032f";
export var icons = "Benefits-module--icons--3b2f1";
export var icon = "Benefits-module--icon--910c7";
export var fadeInAnimation = "Benefits-module--fadeInAnimation--19519";
export var placeHolderShimmer = "Benefits-module--placeHolderShimmer--f7245";